import {
  REQUEST_FAQ_LIST,
} from './mutation-types';

export default {
  [REQUEST_FAQ_LIST] (state, receivedData) {
    state.faqList = receivedData.content;
    state.faqCount = receivedData.totalElements;
  },
}